import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

export const NotificationBubble: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className = '',
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <div
      // todo: add the disabled mode
      className={`ui-notification-bubble ${whiteLabel} ${className}`}
    >
      {children}
    </div>
  )
}
